import { combineReducers } from "redux";
import home from "./home";
import permission from "./permission";
import notification from "./notification";

export const reducers = combineReducers({
  home,
  permission,
  notification
});
